import styled from 'styled-components'
import { Alert, Card, Collapse, Typography } from 'antd'

import { colors } from 'src/common/constants'

// One rhythm for the whole page: 32px between sections, 16px from a heading to its own content,
// 4px between the page title and its subtitle. Sections must read as further apart than anything
// inside them, which is what went wrong when every heading had the same 8px underneath it.
export const HelpColumn = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  display: grid;
  gap: 32px;
  grid-template-rows: repeat(auto-fit, minmax(0, min-content));
`

export const PageTitle = styled(Typography.Title)`
  &&& {
    margin-bottom: 4px;
  }
`

export const SectionTitle = styled(Typography.Title)`
  &&& {
    margin-bottom: 16px;
  }
`

// antd gives a paragraph no top margin, so one placed after a card or a table sticks to it.
export const TrailingParagraph = styled.p`
  &&& {
    margin-top: 16px;
  }
`

export const ButtonRow = styled.div`
  margin-top: 16px;
`

export const GhostCollapse = styled(Collapse)`
  &&& {
    background: transparent;

    .ant-collapse-header {
      font-size: 16px;
      font-weight: 600;
      padding-left: 0;
    }
    .ant-collapse-content-box {
      padding-left: 0;
    }
    .ant-collapse-item {
      border-bottom: 1px solid ${colors.grey2};
    }
    .ant-collapse-arrow {
      color: ${colors.main};
    }
    p:last-child {
      margin-bottom: 0;
    }
  }
`

// Two things antd does not give for free here. Its card border is #f0f0f0 on a white page, so the
// box has neither a surface nor a visible edge: a grey surface makes it read as a panel. And its
// card title is nowrap with an ellipsis, which cuts "Leroy Merlin Italia e Bricocenter Italia" on
// a phone, hiding the one word the reader is scanning for.
// 28px, not smaller: three of the four badges are a wordmark, and below this they turn to mush.
// The name stays in text beside them, so the badge only has to be recognisable, not readable.
export const MethodTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
  }
`

export const MethodCard = styled(Card)`
  &&& {
    height: 100%;
    background: ${colors.grey1};
    border: 1px solid ${colors.grey2};

    .ant-card-head {
      min-height: auto;
      padding: 10px 12px;
      border-bottom: 1px solid ${colors.grey2};
    }
    .ant-card-head-title {
      padding: 0;
      font-size: 15px;
      font-weight: 700;
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
    }
  }
`

// The gesture line carries the accent so the two company cards are told apart at a glance,
// without naming NFC and QR in the heading.
export const GestureLine = styled.p`
  color: ${colors.main};
  font-weight: 600;
  margin-bottom: 8px;
`

export const StepList = styled.ol`
  margin: 0;
  padding-left: 20px;

  li + li {
    margin-top: 4px;
  }
`

export const StyledAlert = styled(Alert)`
  &&& {
    margin-bottom: 0;
  }
`

export const SubjectTag = styled.span`
  font-weight: 600;
`
